const cachios = require('cachios');
const axios = require('axios');

const apiUrl = (location.hostname === 'localhost') ? 'http://localhost:3000/' 
    : ((location.hostname === 'staging.my247ed.com') ?
    'https://staging-api.my247ed.com/'
    : 'https://api.my247ed.com/');
const axiosInstance = axios.create({
    baseURL:  apiUrl
});

import axiosRetry from 'axios-retry';

axiosRetry(axiosInstance, {
    retries: 10,
    retryDelay: axiosRetry.exponentialDelay
});

// all requests will now use this axios instance
const client = cachios.create(axiosInstance, {
    stdTTL: 120
});

const stripePK = (location.hostname === 'localhost' || location.hostname === 'staging.my247ed.com') ? 'pk_test_Mx213mFpG7pCFQ9szH6NQ9ER00rERfI0s8' : 'pk_live_Ylvt97HVw0adW0ilmHdioiT600COyL1MJh';

export {client, axiosInstance, apiUrl, stripePK};
